import { dataStop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconStop = /*#__PURE__*/createIcon(dataStop)
export default IconStop
